import { Spinner } from './ui/spinner'

export function IconLoader({ children, loading, ...props }) {
    return <span {...props}>{loading ? <Spinner /> : children}</span>
}
